import type { ReactNode } from 'react'

type AuthNoticeProps = {
  tone: 'warn' | 'danger'
  title: string
  children: ReactNode
  actions?: ReactNode
}

/**
 * The account gate's two answers: *waiting* (a `pending` sign-up) and *blocked* (`rejected`,
 * `suspended`, or an account that is simply not an administrator). One card, two tones, so the
 * console has exactly one vocabulary for "you are here but you cannot work yet".
 */
export function AuthNotice({ tone, title, children, actions }: AuthNoticeProps) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={`panel-enter w-full rounded-panel bg-surface p-5 ring-1 ring-inset ${
        tone === 'danger' ? 'ring-danger/30' : 'ring-warn/30'
      }`}
    >
      <h2 className="text-title font-semibold text-ink">{title}</h2>
      <div className="mt-2 flex flex-col gap-2 text-ui text-muted">{children}</div>
      {actions && <div className="mt-4 flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
